var scope_0 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0ec909ae3fbde6964f2c981e029fd38d.js').default;
var scope_1 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2e557733b0889515d3194805ca2790c2.js').default;
var scope_2 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/46fc199e55fbd1f5d3eadb8e7e8c0244.js').default;
var scope_3 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/78f34bc7f9285ebd10963a53df3406ac.js').default;
var scope_4 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8550a83035b645c06eafaec9282ef818.js').default;
var scope_5 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/91f68efc4df21f11909d57176fbf5ee4.js').default;
var scope_6 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a09a5e9c8319130fd92ad808eccfc222.js').default;
var scope_7 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_8 = require('/home/circleci/project/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fc4e58d6b81f529d45f88919648e47e8.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8 )
    